import { Component } from '@angular/core';

@Component({
  selector: 'm-app',
  templateUrl: 'embed.component.html',
})
export class EmbedComponent {}
